var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCockpit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icone cockpit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5 7.52513V8.52498C11.675 8.52498 11.825 8.50007 12 8.50007C12.175 8.50007 12.325 8.50008 12.5 8.52498V7.52513C13.475 7.57494 14.4 7.77509 15.25 8.09977L14.875 9C15.2 9.12498 15.5 9.24996 15.8 9.39985L16.175 8.47517C16.65 8.69978 17.075 8.97509 17.5 9.27487L18.575 8.19985C16.75 6.82506 14.475 6 12 6C5.92503 6 1 10.925 1 17.0002V18H2.5V17.0002C2.5 15.9749 2.67502 14.9751 2.97502 14.05L3.90001 14.4249C4 14.0998 4.12503 13.8 4.25001 13.4998L3.32501 13.1248C3.7 12.2749 4.22501 11.4752 4.82501 10.8L5.525 11.5001C5.75001 11.2501 5.97502 11.0002 6.22503 10.7751L5.525 10.075C6.20003 9.45011 6.975 8.89993 7.82501 8.47517L8.2 9.39985C8.5 9.24996 8.8 9.12498 9.125 9L8.75001 8.07487C9.60001 7.75019 10.525 7.57494 11.5 7.52513Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.025 10.6992L19.95 11.7742C20.225 12.1994 20.475 12.6491 20.675 13.0992L19.75 13.4991C19.875 13.7993 20 14.1244 20.1 14.4242L21.025 14.0493C21.325 14.9744 21.5 15.9742 21.5 16.9994V17.9993H23V16.9994C23 14.6493 22.275 12.4992 21.025 10.6992Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.3 16.55C11.25 16.5749 11.2249 16.6252 11.1749 16.675C10.8249 17.0997 10.8749 17.7251 11.3 18.1C11.7249 18.4501 12.3499 18.3998 12.7249 17.9751L20.4999 8.75L11.3 16.55Z",
    fill: "#E9E9F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCockpit);
export default __webpack_public_path__ + "static/media/icon-cockpit.3fb390118fc1a9b2c67f0b935bbbfa40.svg";
export { ForwardRef as ReactComponent };